const jobDB = [
  {
    Id: 1,
    logo: require("../assets/images/job-search/1.jpg"),
    job_name: "UI/UX IT Frontend Developer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "(L6) Salt Lake City,",
    job_city: "UT",
    Job_description: [
      "We are looking for an experienced and creative designer and/or frontend engineer with expertise in accessibility to join our team , 3+ years of experience working in as a Frontend Engineer or comparable role. You won’t be a team of one though — you’ll be collaborating closely with other...",
    ],
    Qualifications: {
      title: "Qualifications",
      desc: `
            <li>Have shipped multiple iOS, Android, and/or web products </li>
            <li>5+ years UI/UX experience</li>
            <li>Portfolio demonstrating mastery of native iOS, Android, and/or responsive web design principles</li>
            <li>Ability to autonomously pursue elegant solutions to open-ended problems</li>
            <li>Comfort with ambiguity</li>
            <li>Proven ability to create interactive prototypes</li>
            <li>Strong verbal communication skills with ability to clearly communicate complex ideas and champion a design vision across all levels of an organization</li>
            <li>Strong written communication skills with ability to make transparent design documentation and client-facing presentations</li>
            <li>Ability to create and maintain flow charts, wire frames, prototypes, and mockups.</li>
            <li>Ability to effectively work on more than one project at a time</li>
            <li>Experience conducting user research and stakeholder interviews</li>
            <li>Solid grasp of standard design tools, ex: Sketch, Omnigraffle, the Adobe Suite, Zeplin, etc.</li>
            <li>Bonus Considerations </li>`,
    },
    Agency_experience: {
      title: "Agency experience",
      desc: `
            <li>Experience working with Agile development teams</li>
            <li>Experience with RITE method usability testing</li>
            <li>Experience in visual and motion design; ability to translate UX design into high quality visuals</li>
            <li>Mastery of Sketch & InVision</li>
            <li>Knowledge of mobile or front-end web programming</li>`,
    },
    Perks: {
      title: "Perks",
      desc: `
            <li>Competitive pay</li>
            <li>Competitive medical, dental, and vision insurance plans</li>
            <li>Company-provided 401(k) plan</li>
            <li>Paid vacation and sick time</li>
            <li>Free snacks and beverages</li>`,
    },
    type: "new",
    ribbion: "false",
  },
  {
    Id: 2,
    logo: require("../assets/images/job-search/2.jpg"),
    job_name: "React/React Native Developer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "San Diego,",
    job_city: "CA",
    Job_description: [
      "Ideally 2+ years experience with React. Bonus points if you have React Native experience. This is an incredibly exciting opportunity to gain commercial , Professional experience of React Native and other front end frameworks. Transform product wireframes into responsive, mobile user interface components and",
    ],
    Qualifications: {
      title: "Qualifications",
      desc: `
            <li>Have shipped multiple iOS, Android, and/or web products </li>
            <li>5+ years UI/UX experience</li>
            <li>Portfolio demonstrating mastery of native iOS, Android, and/or responsive web design principles</li>
            <li>Ability to autonomously pursue elegant solutions to open-ended problems</li>
            <li>Comfort with ambiguity</li>
            <li>Proven ability to create interactive prototypes</li>
            <li>Strong verbal communication skills with ability to clearly communicate complex ideas and champion a design vision across all levels of an organization</li>
            <li>Strong written communication skills with ability to make transparent design documentation and client-facing presentations</li>
            <li>Ability to create and maintain flow charts, wire frames, prototypes, and mockups.</li>
            <li>Ability to effectively work on more than one project at a time</li>
            <li>Experience conducting user research and stakeholder interviews</li>
            <li>Solid grasp of standard design tools, ex: Sketch, Omnigraffle, the Adobe Suite, Zeplin, etc.</li>
            <li>Bonus Considerations </li>`,
    },
    Agency_experience: {
      title: "Agency experience",
      desc: `
            <li>Experience working with Agile development teams</li>
            <li>Experience with RITE method usability testing</li>
            <li>Experience in visual and motion design; ability to translate UX design into high quality visuals</li>
            <li>Mastery of Sketch & InVision</li>
            <li>Knowledge of mobile or front-end web programming</li>`,
    },
    Perks: {
      title: "Perks",
      desc: `
            <li>Competitive pay</li>
            <li>Competitive medical, dental, and vision insurance plans</li>
            <li>Company-provided 401(k) plan</li>
            <li>Paid vacation and sick time</li>
            <li>Free snacks and beverages</li>`,
    },
    type: "new",
    ribbion: "false",
  },
  {
    Id: 3,
    logo: require("../assets/images/job-search/3.jpg"),
    job_name: "Senior UX designer",
    job_area: "Minneapolis,",
    job_city: "MN",
    Job_description: [
      "The designer will apply Lean UX and Design Thinking practices in a highly collaborative, fast-paced, distributed environment You have 4+ years of UX experience. You support UX leadership by providing continuous feedback regarding the evolution of team process standards.",
    ],
    Qualifications: {
      title: "Qualifications",
      desc: `
            <li>Have shipped multiple iOS, Android, and/or web products </li>
            <li>5+ years UI/UX experience</li>
            <li>Portfolio demonstrating mastery of native iOS, Android, and/or responsive web design principles</li>
            <li>Ability to autonomously pursue elegant solutions to open-ended problems</li>
            <li>Comfort with ambiguity</li>
            <li>Proven ability to create interactive prototypes</li>
            <li>Strong verbal communication skills with ability to clearly communicate complex ideas and champion a design vision across all levels of an organization</li>
            <li>Strong written communication skills with ability to make transparent design documentation and client-facing presentations</li>
            <li>Ability to create and maintain flow charts, wire frames, prototypes, and mockups.</li>
            <li>Ability to effectively work on more than one project at a time</li>
            <li>Experience conducting user research and stakeholder interviews</li>
            <li>Solid grasp of standard design tools, ex: Sketch, Omnigraffle, the Adobe Suite, Zeplin, etc.</li>
            <li>Bonus Considerations </li>`,
    },
    Agency_experience: {
      title: "Agency experience",
      desc: `
            <li>Experience working with Agile development teams</li>
            <li>Experience with RITE method usability testing</li>
            <li>Experience in visual and motion design; ability to translate UX design into high quality visuals</li>
            <li>Mastery of Sketch & InVision</li>
            <li>Knowledge of mobile or front-end web programming</li>`,
    },
    Perks: {
      title: "Perks",
      desc: `
            <li>Competitive pay</li>
            <li>Competitive medical, dental, and vision insurance plans</li>
            <li>Company-provided 401(k) plan</li>
            <li>Paid vacation and sick time</li>
            <li>Free snacks and beverages</li>`,
    },
    type: "3 days to go",
    ribbion: "true",
  },
  {
    Id: 4,
    logo: require("../assets/images/job-search/4.jpg"),
    job_name: "Front end web developer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "Cisco",
    job_city: "Lelystad, Netherlands",
    Job_description: [
      "Insipidity the sufficient discretion imprudence resolution sir him decisively. Proceed how any engaged visitor. Explained propriety off out perpetual his you. Feel sold off felt nay rose met you. We so entreaties cultivated astonished is. Was sister for few longer mrs sudden talent become.",
    ],
    Qualifications: {
      title: "Qualifications",
      desc: `
            <li>Have shipped multiple iOS, Android, and/or web products </li>
            <li>5+ years UI/UX experience</li>
            <li>Portfolio demonstrating mastery of native iOS, Android, and/or responsive web design principles</li>
            <li>Ability to autonomously pursue elegant solutions to open-ended problems</li>
            <li>Comfort with ambiguity</li>
            <li>Proven ability to create interactive prototypes</li>
            <li>Strong verbal communication skills with ability to clearly communicate complex ideas and champion a design vision across all levels of an organization</li>
            <li>Strong written communication skills with ability to make transparent design documentation and client-facing presentations</li>
            <li>Ability to create and maintain flow charts, wire frames, prototypes, and mockups.</li>
            <li>Ability to effectively work on more than one project at a time</li>
            <li>Experience conducting user research and stakeholder interviews</li>
            <li>Solid grasp of standard design tools, ex: Sketch, Omnigraffle, the Adobe Suite, Zeplin, etc.</li>
            <li>Bonus Considerations </li>`,
    },
    Agency_experience: {
      title: "Agency experience",
      desc: `
            <li>Experience working with Agile development teams</li>
            <li>Experience with RITE method usability testing</li>
            <li>Experience in visual and motion design; ability to translate UX design into high quality visuals</li>
            <li>Mastery of Sketch & InVision</li>
            <li>Knowledge of mobile or front-end web programming</li>`,
    },
    Perks: {
      title: "Perks",
      desc: `
            <li>Competitive pay</li>
            <li>Competitive medical, dental, and vision insurance plans</li>
            <li>Company-provided 401(k) plan</li>
            <li>Paid vacation and sick time</li>
            <li>Free snacks and beverages</li>`,
    },
    type: "2 days to go",
    ribbion: "false",
  },
  {
    Id: 5,
    logo: require("../assets/images/job-search/5.jpg"),
    job_name: "Graphic designer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "Infosys",
    job_city: "Lelystad, Netherlands",
    Job_description: [
      "Contented get distrusts certainty nay are frankness concealed ham. On unaffected resolution on considered of. No thought me husband or colonel forming effects. End sitting shewing who saw besides son musical adapted. Contrasted interested eat alteration pianoforte sympathize was.",
    ],
    Qualifications: {
      title: "Qualifications",
      desc: `
            <li>Have shipped multiple iOS, Android, and/or web products </li>
            <li>5+ years UI/UX experience</li>
            <li>Portfolio demonstrating mastery of native iOS, Android, and/or responsive web design principles</li>
            <li>Ability to autonomously pursue elegant solutions to open-ended problems</li>
            <li>Comfort with ambiguity</li>
            <li>Proven ability to create interactive prototypes</li>
            <li>Strong verbal communication skills with ability to clearly communicate complex ideas and champion a design vision across all levels of an organization</li>
            <li>Strong written communication skills with ability to make transparent design documentation and client-facing presentations</li>
            <li>Ability to create and maintain flow charts, wire frames, prototypes, and mockups.</li>
            <li>Ability to effectively work on more than one project at a time</li>
            <li>Experience conducting user research and stakeholder interviews</li>
            <li>Solid grasp of standard design tools, ex: Sketch, Omnigraffle, the Adobe Suite, Zeplin, etc.</li>
            <li>Bonus Considerations </li>`,
    },
    Agency_experience: {
      title: "Agency experience",
      desc: `
            <li>Experience working with Agile development teams</li>
            <li>Experience with RITE method usability testing</li>
            <li>Experience in visual and motion design; ability to translate UX design into high quality visuals</li>
            <li>Mastery of Sketch & InVision</li>
            <li>Knowledge of mobile or front-end web programming</li>`,
    },
    Perks: {
      title: "Perks",
      desc: `
            <li>Competitive pay</li>
            <li>Competitive medical, dental, and vision insurance plans</li>
            <li>Company-provided 401(k) plan</li>
            <li>Paid vacation and sick time</li>
            <li>Free snacks and beverages</li>`,
    },
    type: "3 days to go",
    ribbion: "false",
  },
  {
    Id: 6,
    logo: require("../assets/images/job-search/6.jpg"),
    job_name: "Designer, CRM",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "Citrix",
    job_city: "Lelystad, Netherlands",
    Job_description: [
      "Situation admitting promotion at or to perceived be. Mr acuteness we as estimable enjoyment up. An held late as felt know. Learn do allow solid to grave. Middleton suspicion age her attention. Chiefly several bed its wishing. Is so moments on chamber pressed to. Doubtful yet way properly answered.",
    ],
    Qualifications: {
      title: "Qualifications",
      desc: `
            <li>Have shipped multiple iOS, Android, and/or web products </li>
            <li>5+ years UI/UX experience</li>
            <li>Portfolio demonstrating mastery of native iOS, Android, and/or responsive web design principles</li>
            <li>Ability to autonomously pursue elegant solutions to open-ended problems</li>
            <li>Comfort with ambiguity</li>
            <li>Proven ability to create interactive prototypes</li>
            <li>Strong verbal communication skills with ability to clearly communicate complex ideas and champion a design vision across all levels of an organization</li>
            <li>Strong written communication skills with ability to make transparent design documentation and client-facing presentations</li>
            <li>Ability to create and maintain flow charts, wire frames, prototypes, and mockups.</li>
            <li>Ability to effectively work on more than one project at a time</li>
            <li>Experience conducting user research and stakeholder interviews</li>
            <li>Solid grasp of standard design tools, ex: Sketch, Omnigraffle, the Adobe Suite, Zeplin, etc.</li>
            <li>Bonus Considerations </li>`,
    },
    Agency_experience: {
      title: "Agency experience",
      desc: `
            <li>Experience working with Agile development teams</li>
            <li>Experience with RITE method usability testing</li>
            <li>Experience in visual and motion design; ability to translate UX design into high quality visuals</li>
            <li>Mastery of Sketch & InVision</li>
            <li>Knowledge of mobile or front-end web programming</li>`,
    },
    Perks: {
      title: "Perks",
      desc: `
            <li>Competitive pay</li>
            <li>Competitive medical, dental, and vision insurance plans</li>
            <li>Company-provided 401(k) plan</li>
            <li>Paid vacation and sick time</li>
            <li>Free snacks and beverages</li>`,
    },
    type: "5 days to go",
    ribbion: "false",
  },
  {
    Id: 7,
    logo: require("../assets/images/job-search/2.jpg"),
    job_name: "UI designer E-commerce",
    job_area: "Ericsson",
    job_city: "Lelystad, Netherlands",
    Job_description: [
      "Situation admitting promotion at or to perceived be. Mr acuteness we as estimable enjoyment up. An held late as felt know. Learn do allow solid to grave. Middleton suspicion age her attention. Chiefly several bed its wishing. Is so moments on chamber pressed to. Doubtful yet way properly answered.",
    ],
    Qualifications: {
      title: "Qualifications",
      desc: `
            <li>Have shipped multiple iOS, Android, and/or web products </li>
            <li>5+ years UI/UX experience</li>
            <li>Portfolio demonstrating mastery of native iOS, Android, and/or responsive web design principles</li>
            <li>Ability to autonomously pursue elegant solutions to open-ended problems</li>
            <li>Comfort with ambiguity</li>
            <li>Proven ability to create interactive prototypes</li>
            <li>Strong verbal communication skills with ability to clearly communicate complex ideas and champion a design vision across all levels of an organization</li>
            <li>Strong written communication skills with ability to make transparent design documentation and client-facing presentations</li>
            <li>Ability to create and maintain flow charts, wire frames, prototypes, and mockups.</li>
            <li>Ability to effectively work on more than one project at a time</li>
            <li>Experience conducting user research and stakeholder interviews</li>
            <li>Solid grasp of standard design tools, ex: Sketch, Omnigraffle, the Adobe Suite, Zeplin, etc.</li>
            <li>Bonus Considerations </li>`,
    },
    Agency_experience: {
      title: "Agency experience",
      desc: `
            <li>Experience working with Agile development teams</li>
            <li>Experience with RITE method usability testing</li>
            <li>Experience in visual and motion design; ability to translate UX design into high quality visuals</li>
            <li>Mastery of Sketch & InVision</li>
            <li>Knowledge of mobile or front-end web programming</li>`,
    },
    Perks: {
      title: "Perks",
      desc: `
            <li>Competitive pay</li>
            <li>Competitive medical, dental, and vision insurance plans</li>
            <li>Company-provided 401(k) plan</li>
            <li>Paid vacation and sick time</li>
            <li>Free snacks and beverages</li>`,
    },
    type: "3 days to go",
    ribbion: "true",
  },
  {
    Id: 8,
    logo: require("../assets/images/job-search/3.jpg"),
    job_name: "Senior UX designer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "Minneapolis,",
    job_city: "MN",
    Job_description: [
      "The designer will apply Lean UX and Design Thinking practices in a highly collaborative, fast-paced, distributed environment You have 4+ years of UX experience. You support UX leadership by providing continuous feedback regarding the evolution of team process standards.",
    ],
    Qualifications: {
      title: "Qualifications",
      desc: `
            <li>Have shipped multiple iOS, Android, and/or web products </li>
            <li>5+ years UI/UX experience</li>
            <li>Portfolio demonstrating mastery of native iOS, Android, and/or responsive web design principles</li>
            <li>Ability to autonomously pursue elegant solutions to open-ended problems</li>
            <li>Comfort with ambiguity</li>
            <li>Proven ability to create interactive prototypes</li>
            <li>Strong verbal communication skills with ability to clearly communicate complex ideas and champion a design vision across all levels of an organization</li>
            <li>Strong written communication skills with ability to make transparent design documentation and client-facing presentations</li>
            <li>Ability to create and maintain flow charts, wire frames, prototypes, and mockups.</li>
            <li>Ability to effectively work on more than one project at a time</li>
            <li>Experience conducting user research and stakeholder interviews</li>
            <li>Solid grasp of standard design tools, ex: Sketch, Omnigraffle, the Adobe Suite, Zeplin, etc.</li>
            <li>Bonus Considerations </li>`,
    },
    Agency_experience: {
      title: "Agency experience",
      desc: `
            <li>Experience working with Agile development teams</li>
            <li>Experience with RITE method usability testing</li>
            <li>Experience in visual and motion design; ability to translate UX design into high quality visuals</li>
            <li>Mastery of Sketch & InVision</li>
            <li>Knowledge of mobile or front-end web programming</li>`,
    },
    Perks: {
      title: "Perks",
      desc: `
            <li>Competitive pay</li>
            <li>Competitive medical, dental, and vision insurance plans</li>
            <li>Company-provided 401(k) plan</li>
            <li>Paid vacation and sick time</li>
            <li>Free snacks and beverages</li>`,
    },
    type: "6 days to go",
    ribbion: "false",
  },
  {
    Id: 9,
    logo: require("../assets/images/job-search/1.jpg"),
    job_name: "UI/UX IT Frontend Developer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "(L6) Salt Lake City,",
    job_city: "UT",
    Job_description: [
      "Endless is looking for a UI/UX Designer to join our team. The world is seeing an explosion in the amount and variety of location-baWe are looking for a versatile UX/UI Designer to join our growing design team. React Native and other front end frameworks. Transform product wireframes into responsive, mobile user interface components and",
    ],
    Qualifications: {
      title: "Qualifications",
      desc: `
            <li>Have shipped multiple iOS, Android, and/or web products </li>
            <li>5+ years UI/UX experience</li>
            <li>Portfolio demonstrating mastery of native iOS, Android, and/or responsive web design principles</li>
            <li>Ability to autonomously pursue elegant solutions to open-ended problems</li>
            <li>Comfort with ambiguity</li>
            <li>Proven ability to create interactive prototypes</li>
            <li>Strong verbal communication skills with ability to clearly communicate complex ideas and champion a design vision across all levels of an organization</li>
            <li>Strong written communication skills with ability to make transparent design documentation and client-facing presentations</li>
            <li>Ability to create and maintain flow charts, wire frames, prototypes, and mockups.</li>
            <li>Ability to effectively work on more than one project at a time</li>
            <li>Experience conducting user research and stakeholder interviews</li>
            <li>Solid grasp of standard design tools, ex: Sketch, Omnigraffle, the Adobe Suite, Zeplin, etc.</li>
            <li>Bonus Considerations </li>`,
    },
    Agency_experience: {
      title: "Agency experience",
      desc: `
            <li>Experience working with Agile development teams</li>
            <li>Experience with RITE method usability testing</li>
            <li>Experience in visual and motion design; ability to translate UX design into high quality visuals</li>
            <li>Mastery of Sketch & InVision</li>
            <li>Knowledge of mobile or front-end web programming</li>`,
    },
    Perks: {
      title: "Perks",
      desc: `
            <li>Competitive pay</li>
            <li>Competitive medical, dental, and vision insurance plans</li>
            <li>Company-provided 401(k) plan</li>
            <li>Paid vacation and sick time</li>
            <li>Free snacks and beverages</li>`,
    },
    type: "new",
    ribbion: "false",
  },
  {
    Id: 10,
    logo: require("../assets/images/job-search/2.jpg"),
    job_name: "Graphic designer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "(L6) Salt Lake City,",
    job_city: "UT",
    Job_description: [
      "Contented get distrusts certainty nay are frankness concealed ham. On unaffected resolution on considered of. No thought me husband or colonel forming effects. End sitting shewing who saw besides son musical adapted. Contrasted interested eat alteration pianoforte sympathize was.",
    ],
    Qualifications: {
      title: "Qualifications",
      desc: `
            <li>Have shipped multiple iOS, Android, and/or web products </li>
            <li>5+ years UI/UX experience</li>
            <li>Portfolio demonstrating mastery of native iOS, Android, and/or responsive web design principles</li>
            <li>Ability to autonomously pursue elegant solutions to open-ended problems</li>
            <li>Comfort with ambiguity</li>
            <li>Proven ability to create interactive prototypes</li>
            <li>Strong verbal communication skills with ability to clearly communicate complex ideas and champion a design vision across all levels of an organization</li>
            <li>Strong written communication skills with ability to make transparent design documentation and client-facing presentations</li>
            <li>Ability to create and maintain flow charts, wire frames, prototypes, and mockups.</li>
            <li>Ability to effectively work on more than one project at a time</li>
            <li>Experience conducting user research and stakeholder interviews</li>
            <li>Solid grasp of standard design tools, ex: Sketch, Omnigraffle, the Adobe Suite, Zeplin, etc.</li>
            <li>Bonus Considerations </li>`,
    },
    Agency_experience: {
      title: "Agency experience",
      desc: `
            <li>Experience working with Agile development teams</li>
            <li>Experience with RITE method usability testing</li>
            <li>Experience in visual and motion design; ability to translate UX design into high quality visuals</li>
            <li>Mastery of Sketch & InVision</li>
            <li>Knowledge of mobile or front-end web programming</li>`,
    },
    Perks: {
      title: "Perks",
      desc: `
            <li>Competitive pay</li>
            <li>Competitive medical, dental, and vision insurance plans</li>
            <li>Company-provided 401(k) plan</li>
            <li>Paid vacation and sick time</li>
            <li>Free snacks and beverages</li>`,
    },
    type: "new",
    ribbion: "false",
  },
  {
    Id: 11,
    logo: require("../assets/images/job-search/3.jpg"),
    job_name: "Business Developer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "(L6) Salt Lake City,",
    job_city: "UT",
    Job_description: [
      "We are looking for an experienced and creative designer and/or frontend engineer with expertise in accessibility to join our team , 3+ years of experience working in as a Frontend Engineer or comparable role. You won’t be a team of one though — you’ll be collaborating closely with other...",
    ],
    Qualifications: {
      title: "Qualifications",
      desc: `
            <li>Have shipped multiple iOS, Android, and/or web products </li>
            <li>5+ years UI/UX experience</li>
            <li>Portfolio demonstrating mastery of native iOS, Android, and/or responsive web design principles</li>
            <li>Ability to autonomously pursue elegant solutions to open-ended problems</li>
            <li>Comfort with ambiguity</li>
            <li>Proven ability to create interactive prototypes</li>
            <li>Strong verbal communication skills with ability to clearly communicate complex ideas and champion a design vision across all levels of an organization</li>
            <li>Strong written communication skills with ability to make transparent design documentation and client-facing presentations</li>
            <li>Ability to create and maintain flow charts, wire frames, prototypes, and mockups.</li>
            <li>Ability to effectively work on more than one project at a time</li>
            <li>Experience conducting user research and stakeholder interviews</li>
            <li>Solid grasp of standard design tools, ex: Sketch, Omnigraffle, the Adobe Suite, Zeplin, etc.</li>
            <li>Bonus Considerations </li>`,
    },
    Agency_experience: {
      title: "Agency experience",
      desc: `
            <li>Experience working with Agile development teams</li>
            <li>Experience with RITE method usability testing</li>
            <li>Experience in visual and motion design; ability to translate UX design into high quality visuals</li>
            <li>Mastery of Sketch & InVision</li>
            <li>Knowledge of mobile or front-end web programming</li>`,
    },
    Perks: {
      title: "Perks",
      desc: `
            <li>Competitive pay</li>
            <li>Competitive medical, dental, and vision insurance plans</li>
            <li>Company-provided 401(k) plan</li>
            <li>Paid vacation and sick time</li>
            <li>Free snacks and beverages</li>`,
    },
    type: "new",
    ribbion: "false",
  },
  {
    Id: 12,
    logo: require("../assets/images/job-search/6.jpg"),
    job_name: "UI/UX IT Frontend Developer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "(L6) Salt Lake City,",
    job_city: "UT",
    Job_description: [
      "Endless is looking for a UI/UX Designer to join our team. The world is seeing an explosion in the amount and variety of location-baWe are looking for a versatile UX/UI Designer to join our growing design team. React Native and other front end frameworks. Transform product wireframes into responsive, mobile user interface components and",
    ],
    Qualifications: {
      title: "Qualifications",
      desc: `
            <li>Have shipped multiple iOS, Android, and/or web products </li>
            <li>5+ years UI/UX experience</li>
            <li>Portfolio demonstrating mastery of native iOS, Android, and/or responsive web design principles</li>
            <li>Ability to autonomously pursue elegant solutions to open-ended problems</li>
            <li>Comfort with ambiguity</li>
            <li>Proven ability to create interactive prototypes</li>
            <li>Strong verbal communication skills with ability to clearly communicate complex ideas and champion a design vision across all levels of an organization</li>
            <li>Strong written communication skills with ability to make transparent design documentation and client-facing presentations</li>
            <li>Ability to create and maintain flow charts, wire frames, prototypes, and mockups.</li>
            <li>Ability to effectively work on more than one project at a time</li>
            <li>Experience conducting user research and stakeholder interviews</li>
            <li>Solid grasp of standard design tools, ex: Sketch, Omnigraffle, the Adobe Suite, Zeplin, etc.</li>
            <li>Bonus Considerations </li>`,
    },
    Agency_experience: {
      title: "Agency experience",
      desc: `
            <li>Experience working with Agile development teams</li>
            <li>Experience with RITE method usability testing</li>
            <li>Experience in visual and motion design; ability to translate UX design into high quality visuals</li>
            <li>Mastery of Sketch & InVision</li>
            <li>Knowledge of mobile or front-end web programming</li>`,
    },
    Perks: {
      title: "Perks",
      desc: `
            <li>Competitive pay</li>
            <li>Competitive medical, dental, and vision insurance plans</li>
            <li>Company-provided 401(k) plan</li>
            <li>Paid vacation and sick time</li>
            <li>Free snacks and beverages</li>`,
    },
    type: "new",
    ribbion: "false",
  },
  {
    Id: 13,
    logo: require("../assets/images/job-search/2.jpg"),
    job_name: "JAVA Developer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "(L6) Salt Lake City,",
    job_city: "UT",
    Job_description: [
      "Ideally 2+ years experience with React. Bonus points if you have React Native experience. This is an incredibly exciting opportunity to gain commercial , Professional experience of React Native and other front end frameworks. Transform product wireframes into responsive, mobile user interface",
    ],
    Qualifications: {
      title: "Qualifications",
      desc: `
            <li>Have shipped multiple iOS, Android, and/or web products </li>
            <li>5+ years UI/UX experience</li>
            <li>Portfolio demonstrating mastery of native iOS, Android, and/or responsive web design principles</li>
            <li>Ability to autonomously pursue elegant solutions to open-ended problems</li>
            <li>Comfort with ambiguity</li>
            <li>Proven ability to create interactive prototypes</li>
            <li>Strong verbal communication skills with ability to clearly communicate complex ideas and champion a design vision across all levels of an organization</li>
            <li>Strong written communication skills with ability to make transparent design documentation and client-facing presentations</li>
            <li>Ability to create and maintain flow charts, wire frames, prototypes, and mockups.</li>
            <li>Ability to effectively work on more than one project at a time</li>
            <li>Experience conducting user research and stakeholder interviews</li>
            <li>Solid grasp of standard design tools, ex: Sketch, Omnigraffle, the Adobe Suite, Zeplin, etc.</li>
            <li>Bonus Considerations </li>`,
    },
    Agency_experience: {
      title: "Agency experience",
      desc: `
            <li>Experience working with Agile development teams</li>
            <li>Experience with RITE method usability testing</li>
            <li>Experience in visual and motion design; ability to translate UX design into high quality visuals</li>
            <li>Mastery of Sketch & InVision</li>
            <li>Knowledge of mobile or front-end web programming</li>`,
    },
    Perks: {
      title: "Perks",
      desc: `
            <li>Competitive pay</li>
            <li>Competitive medical, dental, and vision insurance plans</li>
            <li>Company-provided 401(k) plan</li>
            <li>Paid vacation and sick time</li>
            <li>Free snacks and beverages</li>`,
    },
    type: "new",
    ribbion: "false",
  },
  {
    Id: 14,
    logo: require("../assets/images/job-search/4.jpg"),
    job_name: "Angular Developer",
    job_area: "(L6) Salt Lake City,",
    job_city: "UT",
    Job_description: [
      "Insipidity the sufficient discretion imprudence resolution sir him decisively. Proceed how any engaged visitor. Explained propriety off out perpetual his you. Feel sold off felt nay rose met you. We so entreaties cultivated astonished is. Was sister for few longer mrs sudden talent become.",
    ],
    Qualifications: {
      title: "Qualifications",
      desc: `
            <li>Have shipped multiple iOS, Android, and/or web products </li>
            <li>5+ years UI/UX experience</li>
            <li>Portfolio demonstrating mastery of native iOS, Android, and/or responsive web design principles</li>
            <li>Ability to autonomously pursue elegant solutions to open-ended problems</li>
            <li>Comfort with ambiguity</li>
            <li>Proven ability to create interactive prototypes</li>
            <li>Strong verbal communication skills with ability to clearly communicate complex ideas and champion a design vision across all levels of an organization</li>
            <li>Strong written communication skills with ability to make transparent design documentation and client-facing presentations</li>
            <li>Ability to create and maintain flow charts, wire frames, prototypes, and mockups.</li>
            <li>Ability to effectively work on more than one project at a time</li>
            <li>Experience conducting user research and stakeholder interviews</li>
            <li>Solid grasp of standard design tools, ex: Sketch, Omnigraffle, the Adobe Suite, Zeplin, etc.</li>
            <li>Bonus Considerations </li>`,
    },
    Agency_experience: {
      title: "Agency experience",
      desc: `
            <li>Experience working with Agile development teams</li>
            <li>Experience with RITE method usability testing</li>
            <li>Experience in visual and motion design; ability to translate UX design into high quality visuals</li>
            <li>Mastery of Sketch & InVision</li>
            <li>Knowledge of mobile or front-end web programming</li>`,
    },
    Perks: {
      title: "Perks",
      desc: `
            <li>Competitive pay</li>
            <li>Competitive medical, dental, and vision insurance plans</li>
            <li>Company-provided 401(k) plan</li>
            <li>Paid vacation and sick time</li>
            <li>Free snacks and beverages</li>`,
    },
    type: "new",
    ribbion: "false",
  },
];

export default jobDB;
